// extracted by mini-css-extract-plugin
export default {"districts":"district_districts__2bSs2","district":"district_district__HIz2+"};